export const IsAuth = "IsAuth";
export const isAuthAction = (value) => {return { type: IsAuth,payload:value }};
